//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import Highcharts from "highcharts";

(function() {
    'use strict';

    // Below are the settings that Highcharts requires to be set globally

    Highcharts.setOptions({
        chart: {
            style: {
                fontFamily: 'proxima-nova, Helvetica, Arial, sans-serif',
                fontWeight: '600',
                letterSpacing: '1px'
            }
        },
        tooltip: { // styling for the tooltip hover
            fontFamily: 'proxima-nova, Helvetica, Arial, sans-serif',
            enabled: true,
            headerFormat: '<span style="font-size: 12px">{point.key}</span><br/>',
            backgroundColor: '#FFF',
            borderWidth: 1,
            borderColor: '#E3E3E3',
            shadow: false,
            style: {
                fontSize: '12px',
                letterSpacing: '0',
                fontWeight: '400'
            },
        },
        xAxis: {
            labels: {
                autoRotation: false,
                style: {
                    textOverflow: 'none'
                }
            },
        },
    });

})();
